import { PageNotFound } from '@components/PageNotFound';
import { PermissionDeny } from '@components/PermissionDeny';
import { withMenuAccess } from '@helpers/with-menu-access';
import { DefaultLayout } from '@layouts/DefaultLayout';
import { HomeLayout } from '@layouts/HomeLayout';
import { Layouts } from '@layouts/Layouts';
import { PermissionLayout } from '@layouts/PermissionLayout';
import { createBrowserHistory } from 'history';
import { Home } from 'pages/Home';
import { DraftReport } from 'pages/draft-report';
import { ManageNative } from 'pages/manage-native';
import { ManageZone } from 'pages/manage-zone';
import { ReportTemplate } from 'pages/report-template';
import { SentReport } from 'pages/sent-report';
import { ViewDraftReport } from 'pages/view-draft-report';
import { ViewSentReport } from 'pages/view-sent-report';
import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import CheckAccessTimeRoute from './CheckAccssTimeRoute';

export const history = createBrowserHistory();

// Every route is wrapped: withMenuAccess sends a user home when the path is absent from their
// sidebar, and it fails OPEN while the menu list is unknown so a slow /users/menu cannot lock anyone
// out. The report screens were left unwrapped when the admin ones were done, so a user without those
// menus got a rendered page and an error toast instead of being sent home. The axios interceptor
// covers what this cannot see - a stale x-menu-id, or a menu revoked while the sidebar is cached.
const routes = [
  {
    path: '/broker-report-group/draft',
    exact: true,
    component: withMenuAccess(DraftReport),
  },
  {
    path: '/broker-report-group/sent',
    exact: true,
    component: withMenuAccess(SentReport),
  },
  {
    path: '/broker-report/draft',
    exact: true,
    component: withMenuAccess(ViewDraftReport),
  },
  {
    path: '/broker-report/sent',
    exact: true,
    component: withMenuAccess(ViewSentReport),
  },
  // Admin screens. The API is the real gate and refuses everyone else, but the route table carries no
  // permission metadata, so without this the page still renders - an empty shell whose every request
  // 403s, which reads as a broken screen rather than one you should not be on. Wrapped so a user whose
  // sidebar has no such menu is sent home instead.
  {
    path: '/broker-report-template/manage',
    exact: true,
    component: withMenuAccess(ReportTemplate),
  },
  {
    path: '/broker-report-template/approve',
    exact: true,
    component: withMenuAccess(ReportTemplate),
  },
  {
    path: '/native',
    exact: true,
    component: withMenuAccess(ManageNative),
  },
  {
    path: '/zone',
    exact: true,
    component: withMenuAccess(ManageZone),
  },
];

export const Routers: React.FC = () => (
  <Router history={history}>
    <Switch>
      <Route path={['/auth', '/']} exact>
        <Layouts layout={HomeLayout} isPublic={true}>
          <Route component={Home} />
        </Layouts>
      </Route>

      <Layouts layout={DefaultLayout} isPublic={true}>
        {routes.map((r) => {
          return (
            <CheckAccessTimeRoute
              key={r.path}
              path={r.path}
              component={r.component}
              exact={r.exact}
            />
          );
        })}
        <Route path={'/error/access'} exact component={PermissionDeny} />
      </Layouts>

      <Route path="*">
        <Layouts layout={PermissionLayout} isPublic={true}>
          <Route component={PageNotFound} />
        </Layouts>
      </Route>
    </Switch>
  </Router>
);
